import { styled } from "@mui/material/styles";
import { ToggleButtonGroup } from "@mui/material";

export default styled(ToggleButtonGroup)(({ theme }) => ({
  border: 0,
  borderRadius: "0px !important",
  "& .MuiToggleButtonGroup-grouped": {
    border: 0,
    borderRadius: 0,
    margin: 0,
    height: "56px",
    width: "42px",

    "& .Mui-selected": {
      backgroundColor: "transparent",
    },

    "&.Mui-disabled": {
      border: 0,
      color: theme.palette.grey[400],
    },

    "&:not(:first-of-type)": {
      borderRadius: "0px !important",
      borderLeftWidth: "1px",
      borderLeftStyle: "solid",
      borderLeftColor: `${theme.palette.grey[300]} !important`,
    },

    "&:first-of-type": {
      borderRadius: "0px !important",
      borderLeftWidth: "1px",
      borderLeftStyle: "solid",
      borderLeftColor: `${theme.palette.grey[300]} !important`,
    },
  },
}));
